<template >
  <div>
    <table class="table table-hover table-borderless"
           cellspacing="0"
           width="100%">
      <thead>
        <tr>
          <th>
            Produit
          </th>
          <th>
            Type
          </th>
          <th>
            Agence
          </th>
          <th>
            Profile du demandeur
          </th>
          <th>
            Quantité
          </th>
          <th>
            Prix Total (EUR)
          </th>
          <th>
            Options incluses
          </th>
          <th>
            Date de debut du contrat
          </th>
          <th>
            &nbsp;
          </th>
        </tr>
      </thead>
      <tbody>
        <suborder v-for="s in cart_computed"
                  :key="s.id"
                  :order="s"
                  @deletesuborder="handleDeletion">
        </suborder>
      </tbody>
    </table>
    <button class="btn btn-complete"
            style="float:right;"
            @click="$emit('cleancart', {cartId:get_active.id})">
      <i class="fa fa-cart-arrow-down"
         aria-hidden="true"></i> Vider le panier
    </button>

    <a class="btn btn-success"
       @click="goToTunnel">
      Se rendre au tunnel d'achat
    </a>

  </div>
</template>

<script>
  import Suborder from './Suborder'
  import ErrorNotification from './ErrorNotification'
  import Select2 from 'components/Form/Select2'
  import cookies from 'cookiesjs'
  import { FORM_ERROR } from 'store/mutation-types'
  import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

  export default {

    components: {
      Suborder,
      ErrorNotification,
      Select2
    },

    data () {
      return {
        expand: false,
        customerId: null
      };
    },

    props: {
      active: {
        required: true,

      }
    },

    computed: {
      get_active: function () {
        if (this.active)
          return this.active
      },
      cart_computed: function () {
        if (this.get_active)
          return this.get_active.suborders
      },

      ...mapGetters('prospects', [
        'selectProspectsList'
      ]),

      ...mapGetters(['anyError']),

      ...mapState(['formError']),

      ...mapState({
        user: 'me'
      })
    },

    watch: {
      anyError (now, before) {
        if (!before && now)
          setTimeout(() => this.anyError && this.setFormError({}), 10000)
      }
    },

    methods: {
      ...mapActions('prospects', [
        'getProspects'
      ]),

      ...mapActions('catalog', [
        'assignToProspect',
        'getCartOwner',
        'get_full_offer_infos',
      ]),

      ...mapMutations({
        setFormError: FORM_ERROR
      }),

      goToTunnel () {
        // in case of: might be useless now
        cookies({ accountType: 'EMPLOYEE' })
        window.open(__PURCHASE_TUNNEL_URL__ + '/user/' + cookies('token'), '_blank')
      },

      assigningToProspectAndGo () {
        const cartId = this.get_active.id
        const params = { cart_id: cartId, customer_id: this.customerId }
        this.setFormError({})
        this.assignToProspect(params)
          //.then(() => this.getCartOwner(this.get_active.id))
          .then(() => this.goToTunnel())
      },

      resetCartOwnership () {
        const cartId = this.get_active.id
        this.setFormError({})
        return this.axios.put(`/carts/${cartId}/reset_owner`)
      },

      // gotoTunnelAsEmployee () {
      //   if (this.get_active.owner_type === "customer")
      //     this.resetCartOwnership()
      //       .then(() => this.getCartOwner(this.get_active.id))
      //       .then(() => this.goToTunnel())
      //   else
      //     this.goToTunnel()
      // }

      handleDeletion(event) {
        this.$emit('deletesuborder', _.assign({cart_id:this.get_active.id}, event))
      }
    },

    created () {
      // no more needed
      // this.getProspects()

      //this.getCartOwner(this.get_active.id)
      //console.log(this.cart + this.active)

    }

  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// client/components/Catalog/CartItem.vue